/* ==========================================================================
   GBSC — Theme JS
   Cart drawer + nav drawer + reveal-on-scroll.
   Cart wraps Shopify /cart.js. Tweaks panel stripped for production.
   ========================================================================== */

(function () {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ============ DRAWERS ============
  const backdrop   = $('#backdrop');
  const cartDrawer = $('#cartDrawer');
  const navDrawer  = $('#navDrawer');

  function openDrawer(el) {
    if (!el) return;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    backdrop && backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeAllDrawers() {
    [cartDrawer, navDrawer].forEach(el => {
      if (!el) return;
      el.classList.remove('open');
      el.setAttribute('aria-hidden', 'true');
    });
    backdrop && backdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Global triggers (data attributes so any template can wire one up)
  document.addEventListener('click', (e) => {
    const cartTrigger = e.target.closest('[data-open-cart]');
    const navTrigger  = e.target.closest('[data-open-nav]');
    const closeTrigger = e.target.closest('[data-close-drawer]');
    if (cartTrigger) { e.preventDefault(); openDrawer(cartDrawer); renderCart(); }
    if (navTrigger)  { e.preventDefault(); openDrawer(navDrawer); }
    if (closeTrigger) { e.preventDefault(); closeAllDrawers(); }
  });

  backdrop && backdrop.addEventListener('click', closeAllDrawers);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllDrawers(); });

  // ============ CART (Shopify /cart.js) ============
  async function getCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  async function addToCart(payload, quantity = 1) {
    // Accept either a FormData (preserves properties[...] for bundles, gift cards, etc.)
    // or (variantId, quantity) for programmatic adds.
    let body;
    let headers;
    if (payload instanceof FormData) {
    body = new URLSearchParams(payload).toString();
      headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' };
    } else {
      body = JSON.stringify({ items: [{ id: payload, quantity }] });
      headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    }
    const r = await fetch('/cart/add.js', { method: 'POST', headers, body });
    if (!r.ok) throw new Error('Add to cart failed');
    await renderCart();
    openDrawer(cartDrawer);
  }

  async function updateLine(line, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    await renderCart();
  }

  function money(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function thumbSrc(url) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/, '_160x160$1$2');
  }

  async function renderCart() {
    if (!cartDrawer) return;
    const cart = await getCart();
    const count = $('#cartCount');
    if (count) count.textContent = cart.item_count;

    const body = $('[data-cart-body]', cartDrawer);
    const foot = $('[data-cart-foot]', cartDrawer);
    if (!body || !foot) return;

    if (!cart.items.length) {
      body.innerHTML = `<div class="empty-state"><h4>Nothing here yet.</h4><p>That's on purpose. Start with the Kit.</p></div>`;
      foot.innerHTML = `<a href="/collections/the-kit" class="btn btn-primary" data-close-drawer>Shop the Kit</a>`;
      return;
    }

    function renderProps(props) {
      if (!props) return '';
      const entries = Object.entries(props).filter(([k, v]) => k && !k.startsWith('_') && v != null && v !== '');
      if (!entries.length) return '';
      return `<ul class="cart-line__props">${
        entries.map(([k, v]) => `<li><span class="cart-line__prop-key">${k}:</span> ${v}</li>`).join('')
      }</ul>`;
    }

    body.innerHTML = cart.items.map((item, i) => `
      <div class="cart-line" data-line="${i + 1}">
        <div class="thumb">${item.image ? `<img src="${thumbSrc(item.image)}" alt="${item.product_title}" loading="lazy" width="72" height="72" style="width:100%;height:100%;object-fit:cover;">` : ''}</div>
        <div>
          <div class="name">${item.product_title}</div>
          <div class="sku mono">${item.sku || ''}</div>
          ${renderProps(item.properties)}
          <div class="qty">
            <button data-qty-delta="-1" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button data-qty-delta="1" aria-label="Increase">+</button>
          </div>
          <button data-qty-delta="remove" class="cart-line-remove" style="background:none;border:none;padding:0;margin-top:8px;color:var(--hs,#3B5364);text-decoration:underline;cursor:pointer;font-size:12px;font-family:inherit;letter-spacing:0.02em;opacity:0.7;">Remove</button>
        </div>
        <div class="price mono">${money(item.final_line_price)}</div>
      </div>
    `).join('');

    foot.innerHTML = `
      <div class="subtotal"><span class="label">Subtotal</span><span class="amt">${money(cart.total_price)}</span></div>
      <p class="caption">Free shipping on every order. Taxes calculated at checkout.</p>
      <a href="/checkout" class="btn btn-primary">Check out →</a>
      <button class="btn btn-ghost" data-close-drawer>Keep shopping</button>
    `;

    $$('[data-qty-delta]', body).forEach(btn => {
      btn.addEventListener('click', (e) => {
        const line = parseInt(e.target.closest('[data-line]').dataset.line, 10);
        const delta = btn.dataset.qtyDelta;
        const current = parseInt(cart.items[line - 1].quantity, 10);
        if (delta === 'remove') updateLine(line, 0);
        else updateLine(line, Math.max(0, current + parseInt(delta, 10)));
      });
    });
  }

  // Add-to-cart forms (Shopify native form markup).
  // Pass the entire FormData so all fields — including properties[...] from
  // bundle / gift-card / app-block widgets — are sent to /cart/add.js.
  // Skip if a section-level handler already called preventDefault (avoids double-add).
  document.addEventListener('submit', async (e) => {
    if (e.defaultPrevented) return;
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    try { await addToCart(new FormData(form)); } catch (err) { console.error(err); }
  });

  // ============ REVEAL ON SCROLL ============
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    $$('.reveal, .section, .kit-callout, .dispatch, .hero-photo').forEach(el => {
      el.classList.add('reveal');
      io.observe(el);
    });
  } else {
    $$('.reveal, .section, .kit-callout, .dispatch, .hero-photo').forEach(el => el.classList.add('in'));
  }

  // Init
  if (cartDrawer) renderCart();

  window.GBSC = { addToCart, renderCart, openDrawer, closeAllDrawers };
})();